import React from "react";
import PrivateRoute from "common/routes/PrivateRoute/PrivateRoute";

export default function CierreProtectedRoute(props){
    return <PrivateRoute allowedroles={["cierre-bancario",'administrator','recepcion']}>
        {props.children}
    </PrivateRoute>;
}